import clsx from 'clsx'
import { Root, List, Item, Viewport } from '@radix-ui/react-navigation-menu'

/* blocks */
import Link from '@/atoms/Link/Link'

/* utils */
import { HeaderProps as Props } from './Header.utils'

/* assets */
import { ReactComponent as PepperLogo } from 'public/assets/icons/PepperLogo_White.svg'

/* styling */
import styles from './desktop.module.css'

function DesktopHeader({ className, primaryCta }: Props): JSX.Element {
  return (
    <nav
      className={clsx(
        className,
        'bg-blue-web-90 text-white | sticky top-0 left-0 | h-18 | z-50'
      )}
    >
      <div className="max-header-width | flex items-center justify-between | mx-auto px-6 | h-full">
        <Link href="/" className="z-1" title="Homepage">
          <PepperLogo style={{ width: 110, height: 33 }} />
        </Link>

        <div className="flex items-center gap-18">
          <Root className={clsx('flex justify-center | h-full | ml-10')}>
            <List className="flex items-center gap-6">
              <Item>
                <Link
                  href="#agenda"
                  className="focus-ring | flex items-center | py-6"
                >
                  Agenda
                </Link>
              </Item>
              <Item>
                <Link
                  href="#speakers"
                  className="focus-ring | flex items-center | py-6"
                >
                  Speakers
                </Link>
              </Item>
              <Item>
                <Link
                  href="#faq"
                  className="focus-ring | flex items-center | py-6"
                >
                  FAQ
                </Link>
              </Item>
              <Item>
                <Link
                  href="#contact"
                  className="focus-ring | flex items-center | py-6"
                >
                  Contact Us
                </Link>
              </Item>
            </List>

            <div className="absolute left-0 top-18 | w-screen">
              <Viewport className={clsx(styles.navViewport)} />
            </div>
          </Root>
        </div>

        <div className={clsx('flex justify-center items-center gap-4')}>
          {primaryCta ? (
            <Link
              href={primaryCta.url}
              className="bg-linear-to-r from-[#1600E5] to-[#4B77F2] flex justify-center items-center gap-2 whitespace-nowrap text-sm font-medium rounded-lg py-3 px-5"
            >
              {primaryCta.title}
            </Link>
          ) : null}
        </div>
      </div>
    </nav>
  )
}

export default DesktopHeader
